import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
  id: number;
  userName?: string;
  firstName?: string;
  lastName?: string;
  emailId?: string;
  phoneNumber?: string;
  roleId?: number;
  restroId?: number;
  captainVoiceEnabled?: boolean;
  /** EMAIL if registered with email/password; PHONE if registered with mobile OTP. */
  primaryLoginMethod?: 'EMAIL' | 'PHONE';
}

interface UserState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  authReady: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  authReady: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAuthReady: (state, action: PayloadAction<boolean>) => {
      state.authReady = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setCaptainVoiceEnabled: (state, action: PayloadAction<boolean>) => {
      if (state.user) {
        state.user.captainVoiceEnabled = action.payload;
      }
    },
  },
});

export const { setUser, setLoading, setAuthReady, setError, clearUser, setCaptainVoiceEnabled } = userSlice.actions;
export default userSlice.reducer;

